module.exports = __webpack_public_path__ + "static/img/fyqd.09f619b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fyqd.jpg
// module id = QalO
// module chunks = 1